import ContactDialog from '@components/ContactDialog/ContactDialog';
import MarkdownMessage from '@gluedigital/markdown-message';
import { useScrollOver } from '@gluedigital/scrollastic';
import { RefObject, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import './Contact.css';

interface ContactProps {
	scrollable: RefObject<HTMLDivElement>;
}

const Contact = ({ scrollable }: ContactProps) => {
	const scrollOver = useScrollOver('#contact', scrollable);
	const [open, setOpen] = useState(false);
	return (
		<>
			<section className="landing-section" id="contact">
				<div className={`container ${scrollOver > 0.3 ? 'enter' : ''}`}>
					<p>
						<MarkdownMessage id="landing-section.contact.text" />
					</p>
					<button onClick={() => setOpen(!open)}>
						<FormattedMessage id="contact-us" />
					</button>
				</div>
			</section>
			{open && <ContactDialog open={open} handleOpen={setOpen} />}
		</>
	);
};

export default Contact;
